"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var WorkbookTemplateWidgetsStyles_1 = require("../../styles/WorkbookTemplateWidgetsStyles");
var WorkbookTemplateThumbnailGalleryItem = /** @class */ (function (_super) {
    __extends(WorkbookTemplateThumbnailGalleryItem, _super);
    function WorkbookTemplateThumbnailGalleryItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.thumbnailSelected = function () {
            _this.props.handleSelectedThumbnail(_this.props.thumbnailIndex);
        };
        _this.handleKeyDown = function (e) {
            if (e.key === 'Enter') {
                _this.props.handleSelectedThumbnail(_this.props.thumbnailIndex);
            }
        };
        _this.disableContextMenu = function (e) {
            e.preventDefault();
        };
        return _this;
    }
    WorkbookTemplateThumbnailGalleryItem.prototype.render = function () {
        return (React.createElement("div", { className: WorkbookTemplateWidgetsStyles_1.WorkbookTemplateThumbnailGalleryStyles.ThumbnailGalleryItemContainer, onContextMenu: this.disableContextMenu },
            React.createElement("img", { alt: this.props.thumbnailName, className: this.props.selected
                    ? WorkbookTemplateWidgetsStyles_1.WorkbookTemplateThumbnailGalleryStyles.ThumbnailGalleryItemSelectedStyle
                    : WorkbookTemplateWidgetsStyles_1.WorkbookTemplateThumbnailGalleryStyles.ThumbnailGalleryItemStyle, draggable: false, onClick: this.thumbnailSelected, onKeyDown: this.handleKeyDown, src: this.props.thumbnailUrl, tabIndex: 0 })));
    };
    return WorkbookTemplateThumbnailGalleryItem;
}(React.Component));
exports.WorkbookTemplateThumbnailGalleryItem = WorkbookTemplateThumbnailGalleryItem;
//# sourceMappingURL=TemplateThumbnailGalleryItem.js.map